import React from "react";
import PropTypes from "prop-types";

import Breadcrumbs from "../../../components/BreadCrumbs";
import ApplicantTagModal from "../../../components/Events/Event/Applicants/modals/ApplicantTagModal";
import ApplicantsListFilters from "./ApplicantsListFilters";
import ApplicantsListPanel from "./components/ApplicantsListPanel";
import { ADMIN_PORTAL_VARIANT } from "./constants";

const ApplicantsListView = ({
  applicants,
  searchQuery,
  onSearchChange,
  filters,
  filterOptions,
  lookupOptions,
  eventShift,
  onFilterChange,
  onDownloadProfiles,
  showDownloadAction,
  selectedCount,
  isLoading,
  list,
  rows,
  columns,
  meta,
  emptyState,
  onCellClick,
  onSelectionChange,
  onPageChange,
  onPageSizeChange,
  tagControls,
  tagOptions,
}) => (
  <div className="applicants-page-container">
    <div>
      <Breadcrumbs
        list={[
          {
            path: "",
            label: applicants.applicantsList,
          },
        ]}
        BreadCrumbHasBackIcon={false}
      />
    </div>
    <ApplicantsListFilters
      applicants={applicants}
      searchQuery={searchQuery}
      onSearchChange={onSearchChange}
      filters={filters}
      filterOptions={filterOptions}
      lookupOptions={lookupOptions}
      eventShift={eventShift}
      onFilterChange={onFilterChange}
      onDownloadProfiles={onDownloadProfiles}
      showDownloadAction={showDownloadAction}
      selectedCount={selectedCount}
    />
    <div className="applicants-page-container__content d-flex flex-column justify-content-between">
      <ApplicantsListPanel
        applicants={applicants}
        shared={lookupOptions.shared}
        isLoading={isLoading}
        list={list}
        rows={rows}
        columns={columns}
        filters={filters}
        meta={meta}
        emptyState={emptyState}
        onCellClick={onCellClick}
        onSelectionChange={onSelectionChange}
        onPageChange={onPageChange}
        onPageSizeChange={onPageSizeChange}
      />
      <ApplicantTagModal
        open={Boolean(tagControls.selectedApplicant)}
        userTag={tagControls.selectedApplicant?.userTag}
        isBulk={tagControls.isBulkTag}
        selectedApplicants={
          tagControls.selectedApplicant ? [tagControls.selectedApplicant] : []
        }
        tagOptions={tagOptions}
        portalVariant={ADMIN_PORTAL_VARIANT}
        onClose={tagControls.closeApplicantTag}
        onSave={tagControls.saveTag}
      />
    </div>
  </div>
);

ApplicantsListView.propTypes = {
  applicants: PropTypes.object.isRequired,
  searchQuery: PropTypes.string.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  filters: PropTypes.object.isRequired,
  filterOptions: PropTypes.object.isRequired,
  lookupOptions: PropTypes.object.isRequired,
  eventShift: PropTypes.array.isRequired,
  onFilterChange: PropTypes.func.isRequired,
  onDownloadProfiles: PropTypes.func.isRequired,
  showDownloadAction: PropTypes.bool.isRequired,
  selectedCount: PropTypes.number.isRequired,
  isLoading: PropTypes.bool.isRequired,
  list: PropTypes.array.isRequired,
  rows: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
  meta: PropTypes.object,
  emptyState: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
  }).isRequired,
  onCellClick: PropTypes.func.isRequired,
  onSelectionChange: PropTypes.func.isRequired,
  onPageChange: PropTypes.func.isRequired,
  onPageSizeChange: PropTypes.func.isRequired,
  tagControls: PropTypes.object.isRequired,
  tagOptions: PropTypes.array.isRequired,
};

ApplicantsListView.defaultProps = {
  meta: null,
};

export default ApplicantsListView;
